module.exports = __webpack_public_path__ + "img/super5ives.dfd9f75b.png";